
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { TypographyPreset, TypographyPresetId } from "@/types/typography";
import FontFamilyInput from "../FontFamily/FontFamilyInput.vue";
import ButtonBarInput from "../ButtonBarInput/ButtonBarInput.vue";
import UnitInput from "../UnitInput/UnitInput.vue";
import DropdownInput from "../DropdownInput.vue";
import ShadowInput from "../ShadowInput/ShadowInput.vue";
import { globalStore } from "@/store/store-accessor";

@Component({
  components: {
    FontFamilyInput,
    ButtonBarInput,
    UnitInput,
    DropdownInput,
    ShadowInput
  }
})
export default class TypographyPresetChooserInput extends Vue {
  @Prop()
  value!: TypographyPresetId;

  get presetsForDropdown() {
    return this.globalPresets.map(x => ({
      text: x.preset.label,
      value: x.preset.id
    }));
  }

  get globalPresets(): TypographyPreset[] {
    return globalStore.typographyPresets
      ? globalStore.typographyPresets.filter(p => p.preset.label && p.preset.id)
      : [];
  }

  updatePreset(presetId: TypographyPresetId) {
    this.$emit("input", presetId);
  }
}
